import CKEditor from "ckeditor4-vue/dist/legacy.js";

// Pin CKEditor 4 core to the supported LTS build.
// This avoids relying on the wrapper's default CDN/version.
CKEditor.editorUrl = "https://cdn.ckeditor.com/4.25.1-lts/full-all/ckeditor.js";

export default CKEditor;
